import { Link, useLocation } from 'react-router';

import type { Quotation } from '~/api/quotations/types';

import { useClientsWithTrashed } from '~/api/clients';
import { SearchParamKeys } from '~/constants/url';
import { r, routes } from '~/providers/RouterProvider/router.routes';
import { cellLinkStyle, desktopTruncateStyle } from '~/styles/utilities.css';
import { clsx } from '~/styles/utils';
import { qs } from '~/utils/searchParams';

type Props = { quotation: Quotation };

export const QuotationClientCell = ({ quotation }: Props) => {
  const { data: clients } = useClientsWithTrashed();
  const { pathname } = useLocation();

  const client = clients.find(({ id }) => id === quotation.clientId);

  if (!client) return '–';

  if (client.deleted) return <div className={clsx(desktopTruncateStyle)}>{client.name}</div>;

  if (client.clientType === 'private' && !client.contacts[0]) {
    return <div className={clsx(desktopTruncateStyle)}>{client.name}</div>;
  }

  const to =
    client.clientType === 'organisation'
      ? r(routes.showClient, { clientId: client.id })
      : r(routes.editContact, { clientId: client.id, contactId: client.contacts[0].id });

  return (
    <div className={clsx(desktopTruncateStyle)}>
      <Link className={cellLinkStyle} to={{ pathname: to, search: qs({ [SearchParamKeys.REDIRECT_PATH]: pathname }) }}>
        {client.name}
      </Link>
    </div>
  );
};
